import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './InfoBox.scss';

var InfoBox = /*#__PURE__*/function (_Component) {
  _inherits(InfoBox, _Component);

  var _super = _createSuper(InfoBox);

  function InfoBox() {
    _classCallCheck(this, InfoBox);

    return _super.apply(this, arguments);
  }

  _createClass(InfoBox, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.topHalf
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.title
      }, this.props.title)), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomHalf
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.info
      }, this.props.info)));
    }
  }]);

  return InfoBox;
}(Component);

export { InfoBox as default };